import { useNavigate } from "react-router-dom";
import { customAuthAxios } from "../../utils/customAuthAxios";
import { useSuccessToast } from "../toast/useSuccessToast";
import { switchImgAppend } from "../../utils/switchImgAppend";

export const useSubmitSoCouponRegister = (restaurantId: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();

  const onSubmit = async (data: any) => {
    try {
      const uploadData = new FormData();
      uploadData.append("restaurant", restaurantId);
      uploadData.append("title", data.title);
      uploadData.append("explanation", data.explanation);
      uploadData.append("notes", data.notes);
      uploadData.append("expiration_date", data.expiration_date);
      switchImgAppend(data.img, uploadData);
      await customAuthAxios.post('socoupon/socoupons/', uploadData)
      showToast('登録が完了しました');
      navigate(-1);
    } catch (error: any) {
    }
  };

  return onSubmit;
};